var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M277 63.21c-7.05 0-125.72.78-133.17.54-.54 0-.83-.8-.29-1.06 4.7-2.33 10-1.86 14.91-3.51 2.88-1 4.64-2.85 6.64-5a13.63 13.63 0 0 1 6.17-4 13 13 0 0 1 6.73-.22c2.41.58 4.5 2 6.79 2.83 5.7 2.15 11.24.1 15.31-4.12 3.36-3.47 6.66-6.75 11.22-8.62a14.9 14.9 0 0 1 11.89-.17c4.35 2 7.34 5.94 11.43 8.32 4.84 2.84 10.64 2.17 16 3s9.47 5.36 14.16 8a10 10 0 0 0 5.12 1.58 30 30 0 0 0 3.12-.44c1.61-.2 3.15-.15 4.23 1.2.24.28.18 1.67-.26 1.67ZM699.89 76.69c-5.15 0-91.78.58-97.23.4-.39 0-.6-.59-.21-.78 3.43-1.7 7.33-1.36 10.89-2.56 2.1-.71 3.39-2.08 4.85-3.65a9.91 9.91 0 0 1 4.5-2.94 9.51 9.51 0 0 1 4.91-.16 42.13 42.13 0 0 1 5 2.06c4.17 1.57 8.21.08 11.18-3 2.45-2.54 4.86-4.93 8.19-6.3a10.88 10.88 0 0 1 8.68-.12c3.14 1.44 5.35 4.36 8.35 6.08 3.53 2.06 7.77 1.58 11.67 2.2s6.91 3.91 10.34 5.81a7.34 7.34 0 0 0 3.74 1.16 22.17 22.17 0 0 0 2.27-.33 3.13 3.13 0 0 1 3.1.88c.15.24.11 1.25-.23 1.25ZM189.85 135.26c-5.15 0-91.79.57-97.23.39a.42.42 0 0 1-.21-.78c3.43-1.7 7.32-1.35 10.89-2.56 2.1-.7 3.39-2.08 4.84-3.65a10.08 10.08 0 0 1 4.51-2.94 9.51 9.51 0 0 1 4.91-.16c1.76.42 3.28 1.43 5 2.06 4.16 1.57 8.21.08 11.18-3 2.45-2.54 4.86-4.93 8.19-6.3a10.92 10.92 0 0 1 8.68-.12c3.18 1.44 5.36 4.34 8.34 6.08 3.54 2.07 7.77 1.58 11.68 2.2s6.91 3.92 10.34 5.81a7.34 7.34 0 0 0 3.73 1.16c.77 0 1.52-.23 2.28-.32a3.08 3.08 0 0 1 3.02.87c.23.24.19 1.26-.15 1.26ZM147.46 237.57c-5.15 0-91.79.57-97.23.4-.39 0-.6-.59-.22-.78 3.44-1.7 7.33-1.36 10.9-2.56 2.1-.71 3.38-2.08 4.84-3.65a10.1 10.1 0 0 1 4.51-2.98 9.62 9.62 0 0 1 4.91-.15c1.76.42 3.28 1.43 5 2.06 4.16 1.57 8.21.08 11.18-3 2.45-2.54 4.86-4.93 8.19-6.3a10.83 10.83 0 0 1 8.68-.12c3.18 1.44 5.36 4.33 8.34 6.07 3.54 2.07 7.77 1.58 11.68 2.21s6.91 3.91 10.33 5.81a7.4 7.4 0 0 0 3.74 1.16 22 22 0 0 0 2.28-.33 3.11 3.11 0 0 1 3.09.88c.15.27.11 1.28-.22 1.28ZM362.6 181.24c-.1.29-136.55 0-134.83 0 .79 0-1.19-1.18-.42-1.55 4.44-2.21 9.3-2.27 14.14-2.71a21.8 21.8 0 0 0 8.26-2c2.57-1.35 4.17-3.68 6-5.84a25.63 25.63 0 0 1 23.3-8.83c9.7 1.52 17.35 8.91 27.07 10.27 5.84.82 11.36-1.44 17.06-2.24a20.92 20.92 0 0 1 12.82 2.33c3.08 1.53 5.92 2.82 9.4 3.05 2.67.19 5.35-.11 8-.14a18 18 0 0 1 11.82 4.72c.46.39 1.84 2.94-2.62 2.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.36 307.03)",
    style: {
      fill: "#ebebeb"
    },
    d: "M171.56 161.32h55.59v291.42h-55.59z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 176.355)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 170.79h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 176.355)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 170.79h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 195.245)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 189.68h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 195.245)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 189.68h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 214.135)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 208.57h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 214.135)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 208.57h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 233.03)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 227.46h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 233.03)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 227.46h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 251.92)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 246.36h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 251.92)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 246.36h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 270.81)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 265.25h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 270.81)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 265.25h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 289.7)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 284.14h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 289.7)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 284.14h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 308.595)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 303.03h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 308.595)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 303.03h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 327.485)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 321.92h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 327.485)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 321.92h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 346.375)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 340.81h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 346.375)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 340.81h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 365.27)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 359.7h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 365.27)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 359.7h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 384.16)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 378.6h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 384.16)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 378.6h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 403.05)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 397.49h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 403.05)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 397.49h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 213.125 421.94)",
    style: {
      fill: "#fff"
    },
    d: "M207.72 416.38h10.81v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M180.19 416.38H191v11.13h-10.81zM180.19 397.49H191v11.13h-10.81zM180.19 378.6H191v11.13h-10.81zM180.19 359.7H191v11.13h-10.81zM180.19 340.81H191v11.13h-10.81zM180.19 321.92H191v11.13h-10.81zM180.19 303.03H191v11.13h-10.81zM180.19 284.14H191v11.13h-10.81zM180.19 265.25H191v11.13h-10.81zM180.19 246.36H191v11.13h-10.81zM180.19 227.46H191v11.13h-10.81zM180.19 208.57H191v11.13h-10.81zM180.19 189.68H191v11.13h-10.81zM180.19 170.79H191v11.13h-10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 199.3 421.94)",
    style: {
      fill: "#fff"
    },
    d: "M193.9 416.38h10.81v11.13H193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 149.65 307.03)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M127.73 161.32h43.83v291.42h-43.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M132.25 416.38h8.92v11.13h-8.92zM143.67 416.38h8.92v11.13h-8.92zM132.25 397.49h8.92v11.13h-8.92zM143.67 397.49h8.92v11.13h-8.92zM132.25 378.6h8.92v11.13h-8.92zM143.67 378.6h8.92v11.13h-8.92zM132.25 359.7h8.92v11.13h-8.92zM143.67 359.7h8.92v11.13h-8.92zM132.25 340.81h8.92v11.13h-8.92zM143.67 340.81h8.92v11.13h-8.92zM132.25 321.92h8.92v11.13h-8.92zM143.67 321.92h8.92v11.13h-8.92zM132.25 303.03h8.92v11.13h-8.92zM143.67 303.03h8.92v11.13h-8.92zM132.25 284.14h8.92v11.13h-8.92zM143.67 284.14h8.92v11.13h-8.92zM132.25 265.25h8.92v11.13h-8.92zM143.67 265.25h8.92v11.13h-8.92zM132.25 246.36h8.92v11.13h-8.92zM143.67 246.36h8.92v11.13h-8.92zM132.25 227.46h8.92v11.13h-8.92zM143.67 227.46h8.92v11.13h-8.92zM132.25 208.57h8.92v11.13h-8.92zM143.67 208.57h8.92v11.13h-8.92zM132.25 189.68h8.92v11.13h-8.92zM143.67 189.68h8.92v11.13h-8.92zM132.25 170.79h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 176.355)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 170.79h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 195.245)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 189.68h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 214.135)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 208.57h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 233.03)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 227.46h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 251.92)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 246.36h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 270.81)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 265.25h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 289.7)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 284.14h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 308.595)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 303.03h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 327.485)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 321.92h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 346.375)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 340.81h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 365.27)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 359.7h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 384.16)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 378.6h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 403.05)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 397.49h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 159.445 421.94)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M154.98 416.38h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M143.67 170.79h8.92v11.13h-8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 348.445)",
    style: {
      fill: "#ebebeb"
    },
    d: "M282.23 244.15h55v208.59h-55z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 305.825 237.23)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M282.23 230.31h47.18v13.83h-47.18z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 329.335)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M288.26 251.37h42.94v155.94h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 268.095)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 266.25h42.94v3.69h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 283.355)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 281.51h42.94v3.68h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 298.62)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 296.78h42.94v3.68h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 313.885)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 312.04h42.94v3.69h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 329.145)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 327.3h42.94v3.68h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 344.41)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 342.57h42.94v3.69h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 359.675)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 357.83h42.94v3.68h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 374.935)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 373.09h42.94v3.68h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 390.2)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 388.36h42.94v3.69h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 309.735 405.46)",
    style: {
      fill: "#fff"
    },
    d: "M288.26 403.62h42.94v3.69h-42.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 265.01 348.445)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M247.78 244.15h34.45v208.59h-34.45z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 267.595 237.23)",
    style: {
      fill: "#a6a6a6"
    },
    d: "M252.95 230.31h29.28v13.83h-29.28z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 329.335)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M251 251.37h26.49v155.94H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 268.095)",
    style: {
      fill: "#fff"
    },
    d: "M251 266.25h26.49v3.69H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 283.355)",
    style: {
      fill: "#fff"
    },
    d: "M251 281.51h26.49v3.68H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 298.62)",
    style: {
      fill: "#fff"
    },
    d: "M251 296.78h26.49v3.68H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 313.885)",
    style: {
      fill: "#fff"
    },
    d: "M251 312.04h26.49v3.69H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 329.145)",
    style: {
      fill: "#fff"
    },
    d: "M251 327.3h26.49v3.68H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 344.41)",
    style: {
      fill: "#fff"
    },
    d: "M251 342.57h26.49v3.69H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 359.675)",
    style: {
      fill: "#fff"
    },
    d: "M251 357.83h26.49v3.68H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 374.935)",
    style: {
      fill: "#fff"
    },
    d: "M251 373.09h26.49v3.68H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 390.2)",
    style: {
      fill: "#fff"
    },
    d: "M251 388.36h26.49v3.69H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 264.24 405.46)",
    style: {
      fill: "#fff"
    },
    d: "M251 403.62h26.49v3.69H251z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 109.845 265.015)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M95.16 247.67h29.37v34.7H95.16z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 85.845 265.65)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M76.53 247.67h18.63v35.97H76.53z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 84.535 273.315)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M75.29 262.99h18.48v20.65H75.29z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 69.525 273.315)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M63.76 262.99h11.53v20.65H63.76z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 112.05 366.425)",
    style: {
      fill: "#ebebeb"
    },
    d: "M88.3 280.11h47.5v172.63H88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 290.585)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 287.53h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 290.585)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 287.53h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 300.945)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 297.89h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 300.945)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 297.89h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 311.305)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 308.25h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 311.305)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 308.25h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 321.67)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 318.62h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 321.67)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 318.62h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 332.03)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 328.98h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 332.03)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 328.98h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 342.39)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 339.34h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 342.39)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 339.34h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 352.755)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 349.7h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 352.755)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 349.7h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 363.115)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 360.06h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 363.115)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 360.06h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 373.475)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 370.43h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 373.475)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 370.43h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 383.84)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 380.79h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 383.84)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 380.79h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 394.2)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 391.15h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 394.2)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 391.15h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 404.56)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 401.51h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 404.56)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 401.51h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 414.925)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 411.87h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 414.925)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 411.87h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 122.9 425.285)",
    style: {
      fill: "#fff"
    },
    d: "M115.43 422.23h14.94v6.1h-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 103.795 425.285)",
    style: {
      fill: "#fff"
    },
    d: "M96.32 422.23h14.94v6.1H96.32z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 69.055 366.425)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M49.81 280.11H88.3v172.63H49.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M53.67 422.23h12.26v6.1H53.67zM69.36 422.23h12.26v6.1H69.36zM53.67 411.87h12.26v6.1H53.67zM69.36 411.87h12.26v6.1H69.36zM53.67 401.51h12.26v6.1H53.67zM69.36 401.51h12.26v6.1H69.36zM53.67 391.15h12.26v6.1H53.67zM69.36 391.15h12.26v6.1H69.36zM53.67 380.79h12.26v6.1H53.67zM69.36 380.79h12.26v6.1H69.36zM53.67 370.43h12.26v6.1H53.67zM69.36 370.43h12.26v6.1H69.36zM53.67 360.06h12.26v6.1H53.67zM69.36 360.06h12.26v6.1H69.36zM53.67 349.7h12.26v6.1H53.67zM69.36 349.7h12.26v6.1H69.36zM53.67 339.34h12.26v6.1H53.67zM69.36 339.34h12.26v6.1H69.36zM53.67 328.98h12.26v6.1H53.67zM69.36 328.98h12.26v6.1H69.36zM53.67 318.62h12.26v6.1H53.67zM69.36 318.62h12.26v6.1H69.36zM53.67 308.25h12.26v6.1H53.67zM69.36 308.25h12.26v6.1H69.36zM53.67 297.89h12.26v6.1H53.67zM69.36 297.89h12.26v6.1H69.36zM53.67 287.53h12.26v6.1H53.67zM69.36 287.53h12.26v6.1H69.36z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.88 396.495)",
    style: {
      fill: "#ebebeb"
    },
    d: "M349.87 340.25h56.03v112.49h-56.03z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 353.435)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 349.99h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 368.155)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 364.71h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 382.875)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 379.43h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 397.595)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 394.15h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 412.315)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 408.87h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 427.035)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 423.59h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 392.125 441.755)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M387.17 438.31h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 353.435)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 349.99h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 368.155)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 364.71h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 382.875)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 379.43h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 397.595)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 394.15h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 412.315)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 408.87h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 427.035)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 423.59h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 377.865 441.755)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M372.91 438.31h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 353.435)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 349.99h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 368.155)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 364.71h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 382.875)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 379.43h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 397.595)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 394.15h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 412.315)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 408.87h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 427.035)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 423.59h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 363.635 441.755)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M358.68 438.31h9.91v6.89h-9.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 368.52 334.39)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M349.87 328.53h37.3v11.72h-37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 361.69 324.905)",
    style: {
      fill: "#ebebeb"
    },
    d: "M349.87 321.28h23.65v7.26h-23.65z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 330.215 396.495)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M310.56 340.25h39.31v112.49h-39.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7"
    },
    d: "M314.58 437.21h8.07v6.89h-8.07zM314.58 422.49h8.07v6.89h-8.07zM314.58 407.77h8.07v6.89h-8.07zM314.58 393.05h8.07v6.89h-8.07zM314.58 378.33h8.07v6.89h-8.07zM314.58 363.61h8.07v6.89h-8.07zM314.58 348.89h8.07v6.89h-8.07zM326.19 437.21h8.07v6.89h-8.07zM326.19 422.49h8.07v6.89h-8.07zM326.19 407.77h8.07v6.89h-8.07zM326.19 393.05h8.07v6.89h-8.07zM326.19 378.33h8.07v6.89h-8.07zM326.19 363.61h8.07v6.89h-8.07zM326.19 348.89h8.07v6.89h-8.07zM337.77 437.21h8.07v6.89h-8.07zM337.77 422.49h8.07v6.89h-8.07zM337.77 407.77h8.07v6.89h-8.07zM337.77 393.05h8.07v6.89h-8.07zM337.77 378.33h8.07v6.89h-8.07zM337.77 363.61h8.07v6.89h-8.07zM337.77 348.89h8.07v6.89h-8.07z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 333.19 334.39)",
    style: {
      fill: "#c7c7c7"
    },
    d: "M316.52 328.53h33.35v11.72h-33.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 340.83 324.905)",
    style: {
      fill: "#dbdbdb"
    },
    d: "M331.79 321.28h18.07v7.26h-18.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m49.81 452.49 81.3-.25 81.29-.09 162.6-.16 162.6.16 81.29.09 81.3.25-81.3.24-81.29.09-162.6.17-162.6-.17-81.29-.09-81.3-.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7 369s22.6 50.19-14.29 50.23-13-51.91-13-51.91-8.54-3.75 1.33-31.77 14.31-28 18.42-28c5.2 0 10 12.11 6.52 30.73-.04-.08 12.97 23.14 1.02 30.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m66.17 452.49 3.48-75.66 3.63 75.65-7.11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m68.23 408.55 13.4-15.67-10.5 17.74-2.9-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72 374.38s-10.53-4.17-18.86 10.37c-8.55 14.91 2.2 24.72 10.71 18.86 0 0 6.69 14 20.05 10.67s15.52-14 15.52-14 11.85.82 12.18-8-8.32-16.77-8.32-16.77-.53-22-14.89-21.86-16.39 20.73-16.39 20.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m97.57 452.49 2.94-65.6 3.08 65.59-6.02.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m99.64 411.54-9.24-18.39 10.76 15.52-1.52 2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.36 369s22.6 50.19-14.29 50.23-13-51.91-13-51.91-8.54-3.75 1.33-31.77 14.31-28 18.42-28c5.2 0 10.05 12.11 6.53 30.73-.04-.08 12.96 23.14 1.01 30.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m676.84 452.49 3.47-75.66 3.64 75.65-7.11.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m678.9 408.55 13.39-15.67-10.5 17.74-2.89-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08 379.34s-19.7 44 12.62 44 11.3-45.52 11.3-45.52 7.48-3.3-1.23-27.83-12.58-24.52-16.18-24.52c-4.56 0-8.78 10.63-5.66 26.94.07 0-11.33 20.36-.85 26.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m182.6 452.48-3.19-66.26-3.04 66.27 6.23-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m180.71 414-11.76-13.7 9.23 15.52 2.53-1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.92 374.38s-10.52-4.17-18.86 10.37c-8.54 14.91 2.2 24.72 10.71 18.86 0 0 6.7 14 20.06 10.67s15.51-14 15.51-14 11.86.82 12.18-8-8.36-16.69-8.36-16.69-.53-22-14.89-21.86-16.35 20.65-16.35 20.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m637.78 452.49 2.93-65.6 3.08 65.59-6.01.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m639.81 411.47-9.2-18.32 11.02 15.49-1.82 2.83zM700.19 67.68v262.07a12.11 12.11 0 0 1-12.11 12.11H284.39a12.12 12.12 0 0 1-12.12-12.11V67.68a12.12 12.12 0 0 1 12.12-12.12h403.69a12.12 12.12 0 0 1 12.11 12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M292.4 72.8h387.67v251.83H292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "m493.31 263.82 75.5-.01-1.37-10.96h31.05l-3.27-19.29-102.42.03.51 30.23zM594.86 72.8l1.9 8.53 59.11-.05-2.86-8.48h-58.15zM629.84 102.75l-4.75-17.31-27.42.02 3.85 17.3 28.32-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "m641.07 153.98 7.54 27.93 31.46-.01v-45.4l-39 17.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "m677.94 132.21-38.58 17.42-11.49-42.74 41.34-.03 8.73 25.35zM292.4 178.73v25.81l7.14 9.84L384.45 198l3-20-27.66-34-42.89 8.92v.07c-2.63 9.52-11.42 18.39-24.5 25.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "M324.81 324.62h64l8.29-68.3-58.26-.04-14.03 68.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M292.4 225.08v61.63h21.65l6.41-27.81-28.06-33.82zM448.16 85.57l-1.93 30.52 31.35-.02.05-30.52-29.47.02zM381.06 132.21l54.37-11.35 3.95-48.06h-47.86l-10.46 59.41zM470.83 81.42l6.79-.01.01-8.61h-6.62l-.18 8.62zM448.43 81.44l16.05-.02.28-8.62h-15.79l-.54 8.64zM292.4 295.31v29.31h12.89l6.76-29.31H292.4zM476.69 256.25l-66.65.12-4.49 43.7 70.84-.01.3-43.81zM403.03 324.62h33.66l1.15-19.48h-32.81l-2 19.48zM476.27 318.21l.09-13.08-29.79.01-.62 13.07h30.32zM445.65 324.62h30.58l.02-3.16h-30.44l-.16 3.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "m383.28 205.63-6.25 40.99-47.95.01-22.15-26.2 76.35-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4 128.78v39.12c6.21-4.54 10.43-9.62 12-15 2.84-9.36-1.94-17.85-12-24.12ZM658.67 72.8l3.48 10.03 17.92 5.87V72.8h-21.4zM633.07 85.44l5.01 17.3 41.99-.03v-9.94l-21.58-7.35-25.42.02zM677.72 106.86l2.35 6.53v-6.53h-2.35zM494.01 305.02l.34 19.6h152.98l32.74-13.13V305l-186.06.02zM573.3 299.87l-3.92-31.5-75.99.01.53 31.5 79.38-.01zM623.58 153.34l-75.53.04 8.35 74.09 84.98-.03-17.8-74.1zM545.04 211.76l-52.61.02.26 15.6 53.88-.02-1.53-15.6zM647.49 252.84l-4.64-19.29-35.83.01 3.61 19.28h36.86z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "m585.6 258.07 4.71 31.49 28.81-.01 1.95 10.32 59-.01v-37.37l-13.47-4.44-81 .02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "m658.5 215.9 7.94 32.21 13.63 4.84v-37.06l-21.57.01zM649.83 186.47l7.02 26.04 23.22-.01v-26.04l-30.24.01zM477.03 205.6l-81.73.02-5.96 44.58 87.39-.02.3-44.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb"
    },
    d: "m491.43 153.4 47.89-.02 5.31 54.2-52.28.02-.92-54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "m490.86 123.28 125.58.37 6.05 25.16-131.13.06-.5-25.59zM398.94 178.4l78.27-.04-.14 21.87-81.05.03 2.92-21.86zM399.68 172.9l-28.96-31.63 55.62-11.84-4.21 43.46-22.45.01zM431.22 172.89l46.03-.02.35-52.1-14.71.01-27.92 6.46-3.75 45.65zM489.52 72.8l.93 43.26 125.35-.07-2.21-9.09-21.16.02-6.94-34.12h-95.97zM330.76 102.94l45.15-.02 5.88-30.12h-42.62l-8.41 30.14zM318.52 146.9l51.05-11.46 5.34-27.38-45.58.03-10.81 38.81zM292.4 72.8v47.25c9.31 3.84 16.36 9 20.49 14.89l18.28-62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffb600"
    },
    d: "M489.57 282.56h-8V115.74h137.25l-3.04-14.22h64.29v8h-54.4l3.04 14.22H489.57v158.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "m503.2 291.24-17.63-7.3-17.63 7.3 17.63-26.16 17.63 26.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M292.4 72.8h106.08v31.07H292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 94.51a1.19 1.19 0 0 1-1.2 1.21H333a1.2 1.2 0 0 1-.9-.4 1.21 1.21 0 0 1 .06-1.71l6.5-5.88a2.78 2.78 0 0 0 .92-2.11 2.86 2.86 0 0 0-.72-1.91 2.82 2.82 0 0 0-2.11-.92 2.86 2.86 0 0 0-1.91.73l-.68.61a1.19 1.19 0 0 1-1.71-.09 1.21 1.21 0 0 1 .09-1.71l.68-.61a5.17 5.17 0 0 1 3.53-1.36 5.26 5.26 0 0 1 3.9 1.73 5.14 5.14 0 0 1 1.35 3.53 5.28 5.28 0 0 1-1.73 3.91l-4.15 3.75h4.68a1.2 1.2 0 0 1 1.2 1.23ZM345 88a9.37 9.37 0 0 1 1.49-5.25 4.62 4.62 0 0 1 8.14 0 10.09 10.09 0 0 1 0 10.49 4.61 4.61 0 0 1-8.14 0A9.39 9.39 0 0 1 345 88Zm8.66 0a7.33 7.33 0 0 0-1.05-3.91 2.56 2.56 0 0 0-2-1.34 2.66 2.66 0 0 0-2.09 1.34 7.33 7.33 0 0 0-1 3.91 7.24 7.24 0 0 0 1 3.88 2.69 2.69 0 0 0 2.09 1.36 2.59 2.59 0 0 0 2-1.36A7.24 7.24 0 0 0 353.7 88ZM360.62 88a9.37 9.37 0 0 1 1.49-5.25 4.62 4.62 0 0 1 8.14 0 10.09 10.09 0 0 1 0 10.49 4.61 4.61 0 0 1-8.14 0 9.39 9.39 0 0 1-1.49-5.24Zm8.66 0a7.33 7.33 0 0 0-1-3.91 2.56 2.56 0 0 0-2-1.34 2.66 2.66 0 0 0-2.09 1.34 7.33 7.33 0 0 0-1.14 3.91 7.24 7.24 0 0 0 1.05 3.88 2.69 2.69 0 0 0 2.09 1.36 2.59 2.59 0 0 0 2-1.36 7.24 7.24 0 0 0 1.09-3.88ZM382.32 88.82v6.31a.6.6 0 0 1-.6.59.58.58 0 0 1-.58-.59v-4.51l-1.54 2.14a.6.6 0 0 1-.49.25.61.61 0 0 1-.49-.25l-1.53-2.14v4.51a.6.6 0 0 1-1.19 0v-6.31a.59.59 0 0 1 .59-.59.55.55 0 0 1 .47.24l2.13 3 2.13-3a.58.58 0 0 1 .48-.24.6.6 0 0 1 .62.59ZM322.22 97.05h-4v-7.94a3.42 3.42 0 0 0-3.42-3.42h-2.72v-4h2.72a7.43 7.43 0 0 1 7.42 7.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M312.9 89.77V77.62l-6.07 6.07 6.07 6.08zM292.4 293.7h387.67v30.92H292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M292.4 293.7h30.92v30.92H292.4zM643.04 276.14h30.92v30.92h-30.92zM335.8 301.55h-1.38l-.28.74a.33.33 0 0 1-.3.2h-.11a.32.32 0 0 1-.18-.41l1.25-3.35a.32.32 0 0 1 .31-.2.3.3 0 0 1 .3.2l1.26 3.35a.34.34 0 0 1-.19.41h-.11a.31.31 0 0 1-.29-.2Zm-.23-.63-.46-1.22-.46 1.22ZM340.08 302a.31.31 0 0 1-.19.4h-.13a.43.43 0 0 1-.22-.06.7.7 0 0 1-.18-.2 1.55 1.55 0 0 1-.12-.69.43.43 0 0 0-.07-.24.55.55 0 0 0-.17-.17 1 1 0 0 0-.32-.13H338v1.23a.32.32 0 1 1-.63 0v-3.36a.31.31 0 0 1 .31-.31h1a1.22 1.22 0 0 1 .78 2.16 1 1 0 0 1 .2.21 1.07 1.07 0 0 1 .18.61 1.24 1.24 0 0 0 0 .34.3.3 0 0 1 .24.21Zm-.79-2.29a.58.58 0 0 0-.59-.59h-.7v1.18h.7a.59.59 0 0 0 .59-.58ZM343.65 302a.33.33 0 0 1-.2.4h-.13a.44.44 0 0 1-.23-.06.7.7 0 0 1-.18-.2 1.55 1.55 0 0 1-.12-.69.43.43 0 0 0-.07-.24.55.55 0 0 0-.17-.17.92.92 0 0 0-.32-.13h-.67v1.23a.32.32 0 1 1-.63 0v-3.36a.31.31 0 0 1 .31-.31h1a1.22 1.22 0 0 1 .78 2.16 1 1 0 0 1 .2.21 1.07 1.07 0 0 1 .18.61 1.87 1.87 0 0 0 0 .34.34.34 0 0 1 .25.21Zm-.8-2.29a.58.58 0 0 0-.59-.59h-.7v1.18h.7a.59.59 0 0 0 .59-.58ZM344.61 298.81a.31.31 0 0 1 .31-.31.32.32 0 0 1 .32.31v3.36a.32.32 0 0 1-.32.32.31.31 0 0 1-.31-.32ZM347.61 302.43 346.1 299a.3.3 0 0 1 .17-.4.31.31 0 0 1 .41.16l1.11 2.64 1.11-2.64a.31.31 0 0 1 .58.24l-1.41 3.33h-.3ZM351.84 301.55h-1.38l-.28.74a.32.32 0 0 1-.29.2h-.11a.32.32 0 0 1-.19-.41l1.26-3.35a.33.33 0 0 1 .6 0l1.26 3.35a.32.32 0 0 1-.19.41h-.11a.32.32 0 0 1-.29-.2Zm-.23-.63-.46-1.22-.46 1.22ZM353.49 302.17v-3.36a.32.32 0 0 1 .63 0v3h1.55a.32.32 0 0 1 0 .64h-1.87a.32.32 0 0 1-.31-.28ZM337.38 307.93V317a.86.86 0 0 1-.86.85.84.84 0 0 1-.85-.85v-7.58l-.61.35a.75.75 0 0 1-.44.13.86.86 0 0 1-.44-1.59l1.89-1.13H336.37a.18.18 0 0 1 .1 0h.17a.1.1 0 0 0 .07 0 .14.14 0 0 1 .09 0h.06c.05 0 .06.05.09.05l.06.05h.07l.06.06v.06l.07.07v.16a.56.56 0 0 0 0 .07v.11ZM345 311.34a3.75 3.75 0 0 1 1.13 2.71 3.85 3.85 0 0 1-1.13 2.7 3.79 3.79 0 0 1-2.7 1.12 3.75 3.75 0 0 1-2.68-1.12.87.87 0 0 1 1.23-1.24 2.06 2.06 0 0 0 2.95 0 2.09 2.09 0 0 0 .61-1.46 2 2 0 0 0-.61-1.48 2 2 0 0 0-1.47-.6 2 2 0 0 0-1.48.6.87.87 0 0 1-1.23 0c-.06-.06-.11-.14-.17-.2s0-.05 0-.05a.08.08 0 0 0 0-.07v-.11c0-.03 0 0 0 0a1.22 1.22 0 0 1 0-.27l.47-4a.88.88 0 0 1 .38-.61s0 0 .06 0h.05a.87.87 0 0 1 .4-.09h4.55a.87.87 0 1 1 0 1.74h-3.8l-.18 1.53a4.06 4.06 0 0 1 1-.14 3.76 3.76 0 0 1 2.62 1.04ZM350.15 309.55a1.16 1.16 0 0 1 1.15 1.15 1.15 1.15 0 1 1-1.15-1.15Zm0 6.13a1.17 1.17 0 0 1 1.15 1.16 1.15 1.15 0 1 1-1.15-1.16ZM358.21 311.32a3.76 3.76 0 0 1 1.13 2.7 3.8 3.8 0 0 1-1.13 2.71 3.8 3.8 0 0 1-5.41 0 .87.87 0 1 1 1.2-1.23 2.06 2.06 0 0 0 1.47.6 2.12 2.12 0 0 0 1.48-.6 2.09 2.09 0 0 0 .61-1.48 2 2 0 0 0-.61-1.47 2.07 2.07 0 0 0-1.47-.61.81.81 0 0 1-.63-.28.86.86 0 0 1 0-1.23l1.57-1.6h-2.5a.86.86 0 0 1-.86-.88.85.85 0 0 1 .86-.86h4.55a.86.86 0 0 1 .88.86 1 1 0 0 1-.11.42 1.06 1.06 0 0 1-.16.21l-1.94 2a3.71 3.71 0 0 1 1.07.74ZM370 315a.85.85 0 0 1-.86.85H369V317a.85.85 0 1 1-1.69 0v-1.17h-4.86a.74.74 0 0 1-.52-.18.83.83 0 0 1-.14-1.19l5.7-7.09.05-.06a.18.18 0 0 0 .08-.05l.06-.05h.24a.1.1 0 0 0 .07 0h.26a.11.11 0 0 0 .08 0h.15l.08.06.07.05h.05l.06.06v.06a.32.32 0 0 1 .06.08v.06a.92.92 0 0 0 0 .09v.06a.15.15 0 0 1 0 .1V314.18h.16a.86.86 0 0 1 1.04.82Zm-2.71-4.65-3.07 3.81h3.07ZM373.55 315.83h-.93v1.63a.42.42 0 0 1-.83 0V313a.41.41 0 0 1 .41-.42h1.35a1.61 1.61 0 1 1 0 3.22Zm-.93-.84h.93a.77.77 0 1 0 0-1.54h-.93ZM380.7 313v4.43a.43.43 0 0 1-.43.41.41.41 0 0 1-.41-.41v-3.13l-1.08 1.5a.41.41 0 0 1-.34.17.43.43 0 0 1-.35-.17l-1.09-1.5v3.16a.42.42 0 0 1-.84 0V313a.42.42 0 0 1 .42-.42.42.42 0 0 1 .33.17l1.49 2.08 1.5-2.08a.41.41 0 0 1 .34-.17.44.44 0 0 1 .46.42ZM620.39 301.5a.29.29 0 0 1 .41-.05 1.82 1.82 0 0 0 1.09.44 1.17 1.17 0 0 0 .71-.21.5.5 0 0 0 .25-.41.37.37 0 0 0-.05-.18.68.68 0 0 0-.17-.17 2.5 2.5 0 0 0-.78-.27 3.27 3.27 0 0 1-.73-.22 1.2 1.2 0 0 1-.53-.44 1 1 0 0 1-.13-.47 1 1 0 0 1 .46-.83 1.68 1.68 0 0 1 1-.3 2.2 2.2 0 0 1 1.24.45.3.3 0 0 1 .08.41.29.29 0 0 1-.4.08 1.67 1.67 0 0 0-.92-.36 1.13 1.13 0 0 0-.64.19.45.45 0 0 0-.21.36.27.27 0 0 0 0 .16.7.7 0 0 0 .15.15 2.06 2.06 0 0 0 .71.25 3 3 0 0 1 .79.24 1.32 1.32 0 0 1 .57.47 1 1 0 0 1 .13.48 1.12 1.12 0 0 1-.48.89 1.82 1.82 0 0 1-1.06.32 2.49 2.49 0 0 1-1.46-.57.3.3 0 0 1-.03-.41ZM625.65 300.94H625v1.23a.32.32 0 0 1-.64 0v-3.36a.32.32 0 0 1 .32-.31h1a1.22 1.22 0 0 1 0 2.44Zm-.7-.63h.7a.6.6 0 0 0 .59-.59.59.59 0 0 0-.59-.59H625ZM627.64 302.17v-3.36a.31.31 0 0 1 .31-.31h1.86a.32.32 0 0 1 0 .63h-1.54v1h1.32a.32.32 0 1 1 0 .64h-1.32v1h1.54a.32.32 0 0 1 0 .64H628a.31.31 0 0 1-.36-.24ZM631 302.17v-3.36a.31.31 0 0 1 .32-.31h1.86a.32.32 0 0 1 0 .63h-1.54v1H633a.32.32 0 0 1 0 .64h-1.32v1h1.54a.32.32 0 0 1 0 .64h-1.86a.32.32 0 0 1-.36-.24ZM634.39 302.17v-3.36a.31.31 0 0 1 .31-.31h.68a2 2 0 0 1 0 4h-.68a.32.32 0 0 1-.31-.33Zm.63-.32h.36a1.36 1.36 0 0 0 0-2.72H635ZM626.77 311.32a3.79 3.79 0 0 1 1.12 2.7 3.83 3.83 0 0 1-6.54 2.71.87.87 0 0 1 1.24-1.23 2 2 0 0 0 1.46.6 2.1 2.1 0 0 0 1.48-.6 2.06 2.06 0 0 0 .62-1.48 2 2 0 0 0-.62-1.47 2.05 2.05 0 0 0-1.46-.61.78.78 0 0 1-.63-.28.88.88 0 0 1 0-1.23l1.57-1.6h-2.49a.87.87 0 0 1-.87-.88.86.86 0 0 1 .87-.86H627a.86.86 0 0 1 .88.86.88.88 0 0 1-.11.42 1 1 0 0 1-.15.21l-1.94 2a3.71 3.71 0 0 1 1.09.74ZM638.58 315a.85.85 0 0 1-.87.85h-.15V317a.85.85 0 1 1-1.7 0v-1.17H631a.76.76 0 0 1-.53-.18.84.84 0 0 1-.14-1.19l5.71-7.09v-.06c0-.06.07 0 .08-.05a.15.15 0 0 0 .06-.05.24.24 0 0 1 .09 0 .08.08 0 0 1 .07 0s0 0 .09 0h.32a.12.12 0 0 0 .08 0h.15l.08.06.08.05s.05 0 .06.06 0 0 0 .06l.06.08a.11.11 0 0 0 0 .06.19.19 0 0 1 0 .09v.06a.28.28 0 0 1 0 .1V314.18h.15a.86.86 0 0 1 1.17.82Zm-2.72-4.65-3.07 3.81h3.07ZM644.87 313v4.43a.43.43 0 0 1-.42.41.41.41 0 0 1-.42-.41v-3.13l-1.03 1.5a.41.41 0 0 1-.34.17.43.43 0 0 1-.35-.17l-1.07-1.5v3.16a.42.42 0 0 1-.84 0V313a.42.42 0 0 1 .42-.42.42.42 0 0 1 .33.17l1.49 2.08 1.5-2.08a.41.41 0 0 1 .34-.17.44.44 0 0 1 .39.42ZM646.69 317.46V313a.42.42 0 1 1 .83 0v1.8h2V313a.42.42 0 1 1 .83 0v4.43a.42.42 0 0 1-.83 0v-1.8h-2v1.8a.42.42 0 0 1-.83 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.49 285.19v-3.36a.31.31 0 0 1 .31-.31.31.31 0 0 1 .32.31v3h1.54a.32.32 0 1 1 0 .63h-1.86a.31.31 0 0 1-.31-.27ZM654.76 281.83a.31.31 0 0 1 .32-.31.32.32 0 0 1 .32.31v3.36a.31.31 0 0 1-.32.31.31.31 0 0 1-.32-.31ZM659.89 281.83v3.36a.32.32 0 0 1-.32.31.31.31 0 0 1-.31-.31v-2.4l-.82 1.14a.32.32 0 0 1-.26.13.3.3 0 0 1-.26-.13l-.82-1.14v2.4a.32.32 0 0 1-.63 0v-3.36a.31.31 0 0 1 .31-.31.3.3 0 0 1 .25.13l1.13 1.57 1.14-1.57a.29.29 0 0 1 .25-.13.32.32 0 0 1 .34.31ZM661.31 281.83a.31.31 0 0 1 .31-.31.32.32 0 0 1 .32.31v3.36a.31.31 0 0 1-.32.31.3.3 0 0 1-.31-.31ZM665.44 282.15h-.9v3a.32.32 0 0 1-.63 0v-3H663a.32.32 0 0 1-.31-.32.31.31 0 0 1 .31-.31h2.43a.32.32 0 0 1 .32.31.33.33 0 0 1-.31.32ZM657.16 298a.85.85 0 0 1-.86.85h-.16V300a.85.85 0 1 1-1.69 0v-1.17h-4.86a.77.77 0 0 1-.52-.18.82.82 0 0 1-.14-1.19l5.7-7.09.05-.06.07-.05h.16a.05.05 0 0 1 .06 0s0 0 .09 0h.56l.08.06h.07l.07.06v.06l.06.08v.06a.39.39 0 0 1 0 .09v.06a.13.13 0 0 1 0 .09v6.36h.16a.86.86 0 0 1 1.1.82Zm-2.71-4.65-3.07 3.81h3.07ZM659.15 295.5a6.57 6.57 0 0 1 1.05-3.69 3.45 3.45 0 0 1 2.86-1.71 3.5 3.5 0 0 1 2.86 1.71 7.11 7.11 0 0 1 0 7.37 3.54 3.54 0 0 1-2.86 1.71 3.5 3.5 0 0 1-2.86-1.71 6.58 6.58 0 0 1-1.05-3.68Zm6.09 0a5.14 5.14 0 0 0-.74-2.75 1.81 1.81 0 0 0-1.44-.94 1.86 1.86 0 0 0-1.46.94 5.14 5.14 0 0 0-.74 2.75 5 5 0 0 0 .74 2.72 1.87 1.87 0 0 0 1.46 1 1.81 1.81 0 0 0 1.44-1 5 5 0 0 0 .74-2.72ZM309.14 316.58h-8v-4h8a3.42 3.42 0 1 0 0-6.83h-2.71v-4h2.71a7.42 7.42 0 1 1 0 14.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M307.24 309.82v-12.15l-6.07 6.08 6.07 6.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M657.59 176.85h16.37v16.37h-16.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M664.97 180.35h1.61v9.38h-1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 665.775 185.035)",
    style: {
      fill: "#fff"
    },
    d: "M664.97 180.35h1.61v9.38h-1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M657.59 204.2h16.37v16.37h-16.37z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 665.775 212.385)",
    style: {
      fill: "#fff"
    },
    d: "M664.97 207.69h1.61v9.38h-1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.05 429.38c3.92-.2 7.83-.3 11.75-.38s7.83-.08 11.74-.12 7.83 0 11.75.12l5.87.14c2 .08 3.92.13 5.87.24-2 .12-3.91.16-5.87.25l-5.87.14c-3.92.08-7.83.07-11.75.11s-7.83 0-11.74-.11-7.8-.18-11.75-.39ZM70.82 416.38c3-.21 6-.3 9-.38s6-.11 9-.12 6 0 9 .11l4.49.14c1.49.09 3 .14 4.49.25-1.5.11-3 .16-4.49.24l-4.49.14c-3 .09-6 .11-9 .12s-6 0-9-.12-6-.17-9-.38ZM51.37 422.93c4.18-.21 8.35-.31 12.53-.39s8.35-.07 12.53-.11 8.35 0 12.52.11l6.26.14c2.09.08 4.18.13 6.27.25-2.09.11-4.18.16-6.27.24l-6.26.14c-4.17.08-8.35.08-12.52.11s-8.35 0-12.53-.11-8.35-.18-12.53-.38ZM389.22 444.1c3.92-.2 7.83-.3 11.75-.38s7.83-.08 11.74-.12 7.83 0 11.75.12l5.87.14c2 .08 3.92.13 5.87.24-1.95.12-3.91.16-5.87.25l-5.87.14c-3.92.08-7.83.07-11.75.11s-7.83 0-11.74-.11-7.83-.18-11.75-.39ZM374.31 437.21c4.18-.21 8.36-.3 12.53-.38s8.35-.08 12.53-.12 8.35 0 12.52.12l6.26.14c2.09.08 4.18.13 6.27.24-2.09.11-4.18.16-6.27.25l-6.26.14c-4.17.07-8.35.07-12.52.11s-8.35 0-12.53-.12-8.35-.17-12.53-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 409.21h99.36S192 362.79 153.2 362.79s-47.98 36.05-49.68 46.42Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 409.21h99.36S192 362.79 153.2 362.79s-47.98 36.05-49.68 46.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89 414.22h99.36s-10.88-46.42-49.68-46.42-47.98 36.05-49.68 46.42Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89 414.22h99.36s-10.88-46.42-49.68-46.42-47.98 36.05-49.68 46.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8 324.53c-2.13 3.39-5.87 40.67-6.09 42s-3.32 7-3.37 8.1-.82 17.89-.38 19a46.08 46.08 0 0 0 3.42 5.71c.55.65 14.63 12.78 16.2 12.94s16.15.27 16.42 0 2-45.12 46.15-45.12 43.71 47.62 44.52 47.78 198.64 4.68 198.64 4.68c0-7.29.57-50.67 43.92-50.67 28.24 0 42.51 23.28 43 40.45.2 7.14-1 15-.6 15 1.31 0 5.76.33 6.53 0s10-6.41 10.76-6.63 6.09-.33 7.39-.65 10.44-8.32 10.6-8.65.44-3.48.49-3.75 9.3-11.58 9.73-12.83.6-11.58.6-12.61S511.93 351 508 348s-31.8-12.72-40-14.19-53-8.15-54.63-9.3-78.17-45-91.49-48.27c-10.76-2.61-135.36 1-141.88 1.31s-24.57 3.58-26.31 3.58-21.75-.1-22.94.44 0 5.33 1.52 6.2-47.78 30.89-51.47 36.76Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.65 321.71c.47.43 8.26.62 9.08.3s49.88-33 49.92-33.92c0-.48-9.2-.36-10.32-.3s-49.58 33.1-48.68 33.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3 321.19c2.13 6.28 259.86 18 261.27 15 1.05-2.26-22-20.77-32.78-26.8s-41.59-23.51-56.79-25.3-45.9-1.64-72.7-1.09c-26.58.49-57.89 1.14-69 5.87-9.71 4.13-31.69 27.33-30 32.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49 317.52c.65 2.36 57.56 8.48 124.27 11.58s99.64 3.59 100.45 3.26-2.28-18.1-3.42-19.57-48.93-25.93-56.43-26.58-48-.73-68.49-.41-63.11 2.78-70.37 5.71c-6.38 2.58-26.67 23.65-26.01 26.01Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.78 286-38.2 38.21c-6.82-.6-13.12-1.2-18.79-1.78L212.22 287c7.55-.45 15.08-.79 21.56-1ZM370.09 328.59l-3.86 3.86c-3.87 0-10.58-.13-20.17-.39l19.88-19.87a4.83 4.83 0 0 1 .85.6c.81 1.05 2.63 10.42 3.3 15.8ZM262.28 285.64l-40.62 40.63c-3.26-.23-6.46-.46-9.58-.71L252 285.69c3.23-.03 6.71-.05 10.28-.05ZM349.49 303.44l-27.84 27.83-9.9-.37 30.88-30.9c2.37 1.18 4.66 2.33 6.86 3.44ZM205.38 287.43 171 321.81l-2.62-.3 33.87-33.87ZM355.41 306.47l-25.09 25.1-2.82-.09 26-26ZM319.36 289.23l-40.3 40.29-2.8-.11 41-41c.67.23 1.37.52 2.1.82ZM178.11 290.05l-28.76 28.75c-1-.19-1.76-.38-2.36-.56l27.58-27.57c1.02-.21 2.2-.42 3.54-.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.19 289.61c.27 0 .39.35.16 1-1.34 3.7-11.77 24.65-14.38 29.54a2.24 2.24 0 0 1-1.47 1l18.38 2a1.51 1.51 0 0 1-.91-1.67c.19-1.16 7-25.79 9.15-31.84a2.55 2.55 0 0 1 1.23-1.29c.36 0-3.14.06-6.46.4-2.89.25-5.7.86-5.7.86ZM205.42 287.42s.34.19.35.86c.12 5.79.77 34.81.21 36.4-.07.21-.16.34-.27.38l3.48.28a1.66 1.66 0 0 1-.32-.87c-.39-4.91-.74-31.5-.68-36.42a1.65 1.65 0 0 1 .33-.83ZM262.56 286.83c.41 1.29 1.08 39.17 1.08 40.4s-1.39 1.51-1.39 1.51l21.54 1s-1.4-.39-1.64-1.05-7-41.5-7-42 1.1-1 1.1-1h-15a2.32 2.32 0 0 1 1.31 1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6 329.86c-2.64.34-8.59 6.52-9 7.83s-2.07 10.11-1.2 11.42 4 4.56 6.74 4.67 16-6.2 17.18-7.28 2.07-7.71.65-9.84-10.97-7.23-14.37-6.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3 346.5c-1.19 1.08-14.46 7.39-17.18 7.28-2.07-.08-4.4-2-5.77-3.49a8.82 8.82 0 0 0 5.31 1.71c1.47-.13 13.89-5.48 15.49-6.94s1.66-7 1.45-8-8.23-6.16-8.23-6.16c4 1.53 8.63 4.32 9.58 5.75 1.41 2.14.54 8.76-.65 9.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.62 379.06c-.73.73-1 6.25-.22 6.74s5.22.43 6.09 0 3.1-4.57 2.94-6-7.94-1.61-8.81-.74ZM470.51 348.51c2.34 3.79 19.57 10.52 26 11.58 4.05.66 18.1 1.55 18.92.81s-6-10.11-9.46-12.39-21-8.16-26.34-7.91-11.48 4.07-9.12 7.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.44 360.9c-.82.74-14.86-.15-18.92-.81-6.44-1.06-23.67-7.79-26-11.59s3.83-7.65 9.13-7.9a10.57 10.57 0 0 1 1.24 0c-4.94 1.82-5.95 5.68-2.94 7.88s12.64 7.36 16.49 8.44 17.55 3.2 18.74 2.25a2.41 2.41 0 0 0 .53-2c1.29 1.94 2.04 3.46 1.73 3.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.63 347.62a8.77 8.77 0 0 1-2.51 6.21 8.91 8.91 0 1 1 0-12.42 8.77 8.77 0 0 1 2.51 6.21Zm0 0a8.7 8.7 0 0 0-2.59-6.13 8.54 8.54 0 0 0-12.08.18 8.54 8.54 0 0 0 6 14.49 8.55 8.55 0 0 0 6.13-2.41 8.7 8.7 0 0 0 2.54-6.13ZM103.52 374.11c-.89-2-1.7-4-2.49-5.95s-1.54-4-2.31-6-1.46-4-2.15-6.08-1.37-4.08-2-6.15c.89 2 1.7 4 2.5 6s1.54 4 2.31 6 1.46 4 2.15 6.08 1.39 3.99 1.99 6.1ZM72.94 374.11c4.28-.08 8.56-.07 12.84-.06l12.84.14 12.83.31c4.28.13 8.56.28 12.83.5-4.28.08-8.56.08-12.84.06l-12.84-.14-12.83-.3c-4.28-.14-8.56-.28-12.83-.51ZM275 332.47l1.47 10.43.64 5.23c.09.87.19 1.74.26 2.63s0 1.75 0 2.63l-.19 21.07L277 385l-.08 5.27v2.63l-.2 2.63-.82 10.47-.9 10.51.53-10.51.61-10.51.15-2.62v-2.64l.05-5.26.11-10.52.36-21c0-.87.07-1.76 0-2.62s-.12-1.74-.2-2.62l-.53-5.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m390.65 337.25 1.78 10.49.88 5.24.22 1.31a7.43 7.43 0 0 1 .16 1.33v2.66c-.06 7.09-.24 14.17-.46 21.26-.05 1.77-.13 3.54-.22 5.32a19.54 19.54 0 0 1-1 5.24c-1 3.41-2.08 6.78-3.3 10.12a76.69 76.69 0 0 1-4.24 9.77l-.66 1.17c-.23.38-.49.75-.73 1.12a8.45 8.45 0 0 1-.81 1.08l-.43.53a1.79 1.79 0 0 1-.78.23c-1.79.19-3.55.21-5.33.27-14.18.29-28.36.16-42.53.07s-28.36-.31-42.53-.57-28.35-.65-42.52-1.17c-7.08-.29-14.16-.52-21.24-1.16a16.33 16.33 0 0 1-2.69-.43c-.5-.19-.8-.42-1.22-.61s-.79-.38-1.19-.56c-1.6-.73-3.26-1.37-4.86-2.17a18.75 18.75 0 0 1-4.47-3 40.68 40.68 0 0 1-3.22-4.29c-4-5.86-7.81-11.84-11.62-17.81s-7.58-12-11.33-18-7.45-12.06-11.1-18.14l-1.36-2.29c-.11-.18-.21-.4-.32-.6l-.16-.3a1.2 1.2 0 0 1-.05-.33l-.13-1.32c-.15-1.77-.29-3.54-.35-5.31v-1.33a8.27 8.27 0 0 1 .29-1.31c.25-.85.53-1.69.83-2.52.59-1.67 1.23-3.33 1.89-5q-1 2.47-1.85 5c-.29.84-.57 1.68-.8 2.53a7.44 7.44 0 0 0-.28 1.29v1.33c.08 1.77.23 3.53.4 5.29l.13 1.33a1.8 1.8 0 0 0 .06.32l.15.28c.11.19.2.37.32.56l1.37 2.28c3.7 6 7.47 12 11.25 18 7.57 12 15.1 24 23 35.72a43.45 43.45 0 0 0 3.16 4.2 18.43 18.43 0 0 0 4.36 2.88c1.58.78 3.23 1.42 4.85 2.15.41.18.82.37 1.22.57s.82.47 1.15.58a16.93 16.93 0 0 0 2.66.45c7 .61 14.14.82 21.22 1.09 14.16.49 28.33.79 42.5 1.06s28.35.53 42.52.69 28.35.3 42.52.06c1.76-.06 3.55-.08 5.28-.26a4.4 4.4 0 0 0 .5-.09l.41-.5a8.13 8.13 0 0 0 .79-1c.24-.37.49-.72.72-1.1l.65-1.15a74.74 74.74 0 0 0 4.24-9.7q1.85-5 3.32-10.08a18.82 18.82 0 0 0 1-5.16l.25-5.3c.28-7.08.51-14.17.63-21.25v-2.66a7.29 7.29 0 0 0-.14-1.31l-.21-1.31-.84-5.25ZM481.88 355.28a47.75 47.75 0 0 1-5.88 4.22c-2 1.3-4.1 2.54-6.15 3.8s-4.16 2.43-6.27 3.6-4.23 2.32-6.39 3.39c2-1.34 4.05-2.61 6.1-3.88l6.18-3.74 6.23-3.67 3.12-1.82a30.11 30.11 0 0 0 3.06-1.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m183.48 376.01 27.62.72 27.61.84 55.22 1.69 55.21 1.93 27.61.97 27.6 1.08-27.61-.72-27.61-.84-55.23-1.69-55.21-1.93-27.61-.97-27.6-1.08zM181.85 336.44l-1.08.05h-.26c-.06 0-.07.05-.11.13a4.18 4.18 0 0 0-.1.51 15.29 15.29 0 0 0 0 2.14c0 .35 0 .71.09 1a2.56 2.56 0 0 0 .12.46h.29c.69.06 1.42.08 2.13.11 2.87.09 5.75.18 8.62.23l4.31.12h3.08a1.3 1.3 0 0 0 .11-.27c0-.16.08-.32.11-.49a12.22 12.22 0 0 0 .09-2.1 9.1 9.1 0 0 0-.1-1.05 1.33 1.33 0 0 0-.11-.4 1.17 1.17 0 0 0-.4-.11c-1.4-.25-2.85-.33-4.28-.47a39.19 39.19 0 0 1 4.33.11 1.18 1.18 0 0 1 .61.19 1.25 1.25 0 0 1 .26.6 8.3 8.3 0 0 1 .15 1.1 12.43 12.43 0 0 1 0 2.2 3.78 3.78 0 0 1-.1.57 1 1 0 0 1-.39.66.33.33 0 0 1-.21.07h-3.16l-4.32-.06c-2.87-.11-5.75-.19-8.63-.4-.72-.06-1.43-.11-2.16-.21a1.79 1.79 0 0 1-.33-.07.83.83 0 0 1-.18-.07.5.5 0 0 1-.13-.19 2.29 2.29 0 0 1-.14-.59 10.11 10.11 0 0 1 0-1.1 14.36 14.36 0 0 1 .21-2.17 3.51 3.51 0 0 1 .15-.53l.07-.14c0-.05.15-.09.18-.08h.26ZM287.54 339.05l-1.08.06h-.27c-.06 0-.07.05-.11.13a2.82 2.82 0 0 0-.09.52 13.75 13.75 0 0 0-.05 2.13A9.1 9.1 0 0 0 286 343a1.47 1.47 0 0 0 .12.46h.29c.7.07 1.42.08 2.14.11 2.87.09 5.74.18 8.62.23l4.31.12h3.07a1.63 1.63 0 0 0 .12-.27c0-.15.07-.31.1-.49a12.22 12.22 0 0 0 .09-2.1 8.74 8.74 0 0 0-.09-1 1.62 1.62 0 0 0-.12-.4c0-.05-.24-.09-.4-.12-1.4-.25-2.85-.33-4.28-.47a42 42 0 0 1 4.34.11 1.21 1.21 0 0 1 .61.19 1.33 1.33 0 0 1 .25.6 10.8 10.8 0 0 1 .16 1.1 13.59 13.59 0 0 1 0 2.21q0 .27-.09.57a1 1 0 0 1-.4.65.32.32 0 0 1-.21.07h-3.16l-4.32-.06c-2.88-.1-5.76-.19-8.63-.4-.73-.06-1.44-.11-2.17-.21a1.16 1.16 0 0 1-.32-.07l-.18-.06a.81.81 0 0 1-.14-.19 2 2 0 0 1-.13-.59 10.35 10.35 0 0 1-.05-1.1 14.25 14.25 0 0 1 .22-2.17 2.69 2.69 0 0 1 .14-.54.5.5 0 0 1 .08-.14.19.19 0 0 1 .17-.07h.27Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 152.34,
    cy: 411.39,
    r: 41.1,
    transform: "rotate(-81.13 152.337 411.388)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.34,
    cy: 411.39,
    r: 30.01,
    transform: "rotate(-80.74 152.321 411.381)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.34,
    cy: 411.39,
    r: 27.67,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68 404.45H148c2.93-4.24-7.29-19-7.29-19l4.57-1.53c3 5.22 4.56 6.75 7.06 6.75s4-1.53 7.08-6.75l4.56 1.53s-10.23 14.76-7.3 19ZM147.26 405l-2.68 8.26c-3.13-4.09-20.34 1.06-20.34 1.06v-4.82c5.91-1.28 7.83-2.25 8.6-4.63s-.21-4.3-4.23-8.81l2.87-3.87s10.85 14.27 15.78 12.81ZM144.85 414.1l7 5.11c-4.87 1.7-5.29 19.67-5.29 19.67l-4.56-1.45c.6-6 .27-8.14-1.75-9.61s-4.15-1.13-9.69 1.3l-2.79-3.92s16.97-5.95 17.08-11.1ZM152.78 419.21l7-5.11c.12 5.15 17.08 11.1 17.08 11.1l-2.8 3.93c-5.53-2.44-7.66-2.78-9.68-1.31s-2.35 3.6-1.75 9.61l-4.59 1.45s-.39-17.97-5.26-19.67ZM160.09 413.24l-2.68-8.24c4.93 1.48 15.83-12.81 15.83-12.81l2.87 3.87c-4 4.51-5 6.43-4.24 8.81s2.7 3.35 8.61 4.64v4.81s-17.26-5.18-20.39-1.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.34,
    cy: 411.2,
    r: 8.03,
    transform: "rotate(-81.11 152.327 411.187)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.88,
    cy: 411.39,
    r: 41.1,
    transform: "rotate(-20.13 439.921 411.397)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.88,
    cy: 411.39,
    r: 30.01,
    transform: "rotate(-80.2 439.88 411.391)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.88,
    cy: 411.39,
    r: 27.67,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23 404.45h-8.69c2.93-4.24-7.29-19-7.29-19l4.57-1.53c3 5.22 4.56 6.75 7.06 6.75s4-1.53 7.08-6.75l4.56 1.53s-10.22 14.76-7.29 19ZM434.81 405l-2.68 8.26c-3.13-4.09-20.34 1.06-20.34 1.06l-.05-4.82c5.91-1.28 7.83-2.25 8.6-4.63s-.21-4.3-4.23-8.81l2.87-3.87s10.9 14.27 15.83 12.81ZM432.4 414.1l7 5.11c-4.86 1.7-5.28 19.67-5.28 19.67l-4.6-1.45c.61-6 .28-8.14-1.74-9.61s-4.16-1.13-9.69 1.3l-2.79-3.92s16.99-5.95 17.1-11.1ZM440.33 419.21l7-5.11c.12 5.15 17.08 11.1 17.08 11.1l-2.8 3.93c-5.53-2.44-7.66-2.78-9.68-1.31s-2.35 3.6-1.75 9.61l-4.59 1.45s-.39-17.97-5.26-19.67ZM447.64 413.24 445 405c4.93 1.48 15.83-12.81 15.83-12.81l2.87 3.87c-4 4.51-5 6.43-4.24 8.81s2.7 3.35 8.61 4.64v4.81s-17.31-5.18-20.43-1.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.92 411.2a8 8 0 1 1-8-8 8 8 0 0 1 8 8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.78 317c-1.5 1.5-1.36 14.9-.27 16s16 2.07 17.17-6.25-14.56-12.06-16.9-9.75Z",
    style: {
      fill: "#ffb600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.13 325H403c-31.53-20.81-74.81-41.38-74.81-41.38l7.18-1.74c26.2 12.68 76.71 41.68 78 42.62a8 8 0 0 0 1.76.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.52 384.55a53.29 53.29 0 0 1 9.21-11.32 58.31 58.31 0 0 1 11.84-8.61 57.45 57.45 0 0 1 28.26-7l3.68.18 1.83.08c.61.07 1.22.17 1.83.25l3.64.52c1.2.25 2.39.57 3.58.85a45.28 45.28 0 0 1 13.48 5.78 47.23 47.23 0 0 1 10.91 9.76 64.86 64.86 0 0 1 7.71 12.4 69.06 69.06 0 0 0-8.08-12.09 46.5 46.5 0 0 0-10.94-9.35c-8.23-5.14-18-7.23-27.64-7.32a58.88 58.88 0 0 0-14.37 1.55 56.54 56.54 0 0 0-13.53 5.09 57.45 57.45 0 0 0-11.87 8.31 54.85 54.85 0 0 0-9.54 10.92ZM391.45 384.55a53.29 53.29 0 0 1 9.21-11.32 58.31 58.31 0 0 1 11.84-8.61 57.45 57.45 0 0 1 28.26-7l3.68.18 1.83.08c.61.07 1.22.17 1.83.25l3.64.52c1.2.25 2.39.57 3.58.85a45.28 45.28 0 0 1 13.48 5.78 47.23 47.23 0 0 1 10.91 9.76 64.86 64.86 0 0 1 7.71 12.4 69.06 69.06 0 0 0-8.08-12.09A46.5 46.5 0 0 0 468.4 366c-8.23-5.14-18-7.23-27.64-7.32a58.88 58.88 0 0 0-14.37 1.55 56.54 56.54 0 0 0-13.53 5.09 57.45 57.45 0 0 0-11.86 8.27 54.85 54.85 0 0 0-9.55 10.96ZM109.47 316.35c6.4-5 12.9-9.92 19.44-14.75s13.15-9.58 20-14.09c.86-.55 1.73-1.09 2.62-1.61.44-.26.89-.51 1.36-.74a8.36 8.36 0 0 1 1.5-.57c2-.57 3.94-1.07 5.92-1.57 4-1 7.91-1.91 11.91-2.68a69.31 69.31 0 0 1 12.18-1.25c4.07-.09 8.14-.08 12.2.11-4.06 0-8.13.11-12.18.37a70.28 70.28 0 0 0-12 1.5c-4 .89-7.92 1.81-11.85 2.82-2 .5-3.94 1-5.87 1.6a7 7 0 0 0-1.35.52c-.43.22-.87.46-1.3.72-.87.51-1.72 1.06-2.57 1.6-6.81 4.41-13.4 9.19-20 13.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.25 370.16c-31.48 7.2-31.94 42.86-31.94 49.4 0 0-197.82-4.51-198.64-4.68-.66-.14-.46-31.36-23.8-43.25 10.48 5.18 23.92 17.74 29 36.08.55 2 29.36 5 78.6 6.59s92 .58 100.18-.56 17.66-43.74 46.6-43.58ZM528.13 391.83c-.43 1.26-9.68 12.56-9.73 12.83s-.32 3.42-.49 3.76-9.3 8.31-10.6 8.64-6.63.43-7.39.65-10 6.3-10.77 6.63-5.21 0-6.52 0c-.39 0 .81-7.86.6-15-.35-12.46-8-28.14-22.91-35.8 8.11 1.73 21.64 12.8 27.1 24.22s4.06 12.26 5.33 13.63 5.52-1.4 7.47-1.89 8.32-.65 10.77-1.14 2.84-4.9 4.52-5.88 10.2-7.77 12.62-10.65Z",
    style: {
      opacity: 0.1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner2);
export default __webpack_public_path__ + "static/media/banner2.f3e0371dff18e06b12650db1c65b0a49.svg";
export { ForwardRef as ReactComponent };